// We added these custom breakpoints since the default provided by Angular Layout are inconsistent with how we approach responsive design - Harry
export enum customBreakpointsEnum {
  '2xs' = '(min-width: 320px)',
  'xs' = '(min-width:600px)',
  'sm' = '(min-width: 960px)',
  'md' = '(min-width:1280px)',
  'lg' = '(min-width: 1440px)',
  'xl' = '(min-width: 1920px)',
  '2xl' = '(min-width: 2560px)',
}